import { ActionIcon } from "rizzui/action-icon";
import { Button } from "rizzui/button";
import { Text } from "rizzui/typography";
import ArrowRightUp from "../../assets/arrowRightUp";
import { type } from "./dataMapping";
import { useUpdateProfile } from "../../hooks/useProfileDetails";
import { useNavigate } from "react-router";
import { useNotifcication } from "../../hooks/useNotification";
import { useQueryClient } from "@tanstack/react-query";
export default function ConnectionSuccesful({
  type,
  parameters,
}: {
  type: string;
  parameters: string[];
}) {
  return (
    <div className="border-[0.5px] border-muted p-[32px] rounded-[8px] w-full flex-1">
      <div className="flex flex-col gap-[32px]">
        <div className="flex flex-col gap-[8px] text-center">
          <Text className="font-ibmPlexSerif font-[600] text-[18px] text-primary-dark">
            Connection successful
          </Text>
          <Text className="text-[#758599] font-switzer text-[14px] font-[400] w-[223px] mx-auto">
            Your {type} integration is ready to go live
          </Text>
        </div>
        <div className="flex flex-col gap-[16px]">
          <div className="bg-[#2FCA8C1A] p-[16px] rounded-[8px] border border-[#00A861] w-full">
            <div className="flex flex-col gap-[8px]">
              {parameters.map((param, index) => (
                <Text
                  className="text-primary-dark font-[400] font-switzer text-[12px]"
                  key={index}
                >
                  {param}
                </Text>
              ))}
            </div>
          </div>

          {type === "Google sheet" && (
            <ActionIcon className="!bg-transparent w-full">
              <Text className="text-primary-dark font-switzer text-[14px] font-[500] underline flex items-center gap-[2px]">
                Go to sheet <ArrowRightUp className={"text-primary-dark"} />
              </Text>
            </ActionIcon>
          )}
        </div>
      </div>
    </div>
  );
}

export function Buttons({
  onSubmit,
  onBack,
  shouldDisable,
  type,
}: {
  onSubmit: React.Dispatch<React.SetStateAction<string>>;
  onBack: React.Dispatch<React.SetStateAction<string>>;
  shouldDisable?: boolean;
  type?: type;
}) {
  const { mutateAsync, isPending } = useUpdateProfile();
  const navigate = useNavigate();
  const { openNotification } = useNotifcication();
  const queryClient = useQueryClient();

  const completeSetup = () => {
    mutateAsync({ is_contact_import: true })
      .then((res) => {
        if (res.success) {
          sessionStorage.removeItem(`Ringconnect_${type}_optional_fields`);
          sessionStorage.removeItem(`Ringconnect_${type}_default_fields`);
          queryClient.invalidateQueries({ queryKey: ["user_profile"] });
          navigate("/dashboard");
        }
      })
      .catch((e) => {
        openNotification({ status: "error", message: e });
      });
  };
  return (
    <div className="flex justify-between">
      <Button
        className="w-[134px] h-[35px] rounded-[4px] !bg-[#F2F2F2] dark:!bg-muted"
        onClick={() => {
          onSubmit("");
          onBack("data-mapping");
        }}
      >
        <Text className="font-switzer text-[12px] font-[400] text-primary-dark">
          Go back
        </Text>
      </Button>
      <Button
        className="!bg-btn h-[35px] w-[226px] rounded-[4px]"
        disabled={shouldDisable}
        onClick={completeSetup}
        isLoading={isPending}
      >
        <Text className="font-switzer text-[12px] font-[400] text-background">
          Complete setup
        </Text>
      </Button>
    </div>
  );
}
